import React from 'react';

// Components
import Iconify from '../../../Iconify';
import Loading from '../../../Loading';

// Components
import { InstructionsSpei } from '../../shared/components/instructions';
import { SpeiWarnings } from '../../shared/components/spei-warnings';

// Assets
import iconoBanco from '../../shared/assets/icono-banco.png';
import iconoConcepto from '../../shared/assets/icono-concepto.png';
import iconoHeader from '../../shared/assets/icono-usa-esta-info-para-tu-transf.png';
import iconoTarjeta from '../../shared/assets/icono-tarjeta.png';

// Hooks
import { useBitsoClabe } from './use-bitso-clabe';
import { useCopyClipboard } from '../../shared/hooks/use-copy-clipboard';

import styles from '../../muwe/spei/spei.module.css';


export const SpeiBitso = () => {
  const { copyToClipboard, copiedField } = useCopyClipboard();
  const { data: userClabe, isLoading, isError, refetch } = useBitsoClabe();

  const bankName = userClabe?.bank ?? '';
  const clabeValue = userClabe?.clabe ?? '';
  const conceptValue = 'DEPOSITO PICKWIN';

  const canShowData =
    userClabe && userClabe.enabled !== false && Boolean(clabeValue);

  if (isLoading) {
    return (
      <div className={styles.wrapper}>
        <Loading label="Cargando información..." />
      </div>
    );
  }

  if (isError || !canShowData) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.header}>
            <h2 className={styles.headerTitle}>
              No pudimos cargar tu información de{' '}
              <span className={styles.headerTitleHighlight}>transferencia Bitso.</span>
            </h2>
          </div>
          <div className={styles.buttonContainer}>
            <button type="button" className="payment-button" onClick={() => refetch()}>
              <span className={styles.buttonText}>Reintentar</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headerIcon}>
            <img src={iconoHeader} alt="Icono de información" />
          </div>
          <h2 className={styles.headerTitle}>
            Usa esta información para{' '}
            <span className={styles.headerTitleHighlight}>hacer tu transferencia</span>
          </h2>
        </div>

        <InstructionsSpei />

        <div className={styles.fieldsContainer}>
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Banco</label>
            <div
              className={`${styles.fieldInput} ${
                copiedField === 'banco' ? styles.fieldInputCopied : ''
              }`}
              onClick={() => copyToClipboard(bankName, 'banco')}
            >
              <img src={iconoBanco} alt="Icono banco" className={styles.fieldIcon} />
              <span className={styles.fieldValue}>{bankName}</span>
              {copiedField === 'banco' ? (
                <span className={styles.copiedFeedback}>
                  <Iconify icon="material-symbols:check-circle" className={styles.copiedIcon} />
                  <span className={styles.copiedText}>¡Copiado!</span>
                </span>
              ) : (
                <Iconify icon="material-symbols:content-copy" className={styles.copyIcon} />
              )}
            </div>
          </div>

          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Cuenta CLABE</label>
            <div
              className={`${styles.fieldInput} ${
                copiedField === 'clabe' ? styles.fieldInputCopied : ''
              }`}
              onClick={() => copyToClipboard(clabeValue, 'clabe')}
            >
              <img src={iconoTarjeta} alt="Icono tarjeta" className={styles.fieldIcon} />
              <span className={styles.fieldValue}>{clabeValue}</span>
              {copiedField === 'clabe' ? (
                <span className={styles.copiedFeedback}>
                  <Iconify icon="material-symbols:check-circle" className={styles.copiedIcon} />
                  <span className={styles.copiedText}>¡Copiado!</span>
                </span>
              ) : (
                <Iconify icon="material-symbols:content-copy" className={styles.copyIcon} />
              )}
            </div>
          </div>

          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Concepto</label>
            <div
              className={`${styles.fieldInput} ${
                copiedField === 'concepto' ? styles.fieldInputCopied : ''
              }`}
              onClick={() => copyToClipboard(conceptValue, 'concepto')}
            >
              <img src={iconoConcepto} alt="Icono concepto" className={styles.fieldIcon} />
              <span className={styles.fieldValue}>{conceptValue}</span>
              {copiedField === 'concepto' ? (
                <span className={styles.copiedFeedback}>
                  <Iconify icon="material-symbols:check-circle" className={styles.copiedIcon} />
                  <span className={styles.copiedText}>¡Copiado!</span>
                </span>
              ) : (
                <Iconify icon="material-symbols:content-copy" className={styles.copyIcon} />
              )}
            </div>
          </div>
        </div>

        <SpeiWarnings />
      </div>
    </div>
  );
};
